import React from "react"
import { useFormContext } from "react-hook-form"

import styles from "./PhaseBudgetItemRow.module.css"

import { getDefaultRate } from "~/helpers/rate-helpers"

import RoleTableRow from "../RoleTableRow"
import { ProjectBudgetFormData } from "../formTypes"
import { getEffectiveRate } from "../projectBudgetHelpers"
import { BudgetedPhaseAndRole, BudgetedRole, RateCard } from "../types"

type Props = {
  phaseId: number
  role: BudgetedRole
  phaseRole: BudgetedPhaseAndRole
  rateCard: RateCard
  defaultFullTimeMinutes: number
  canDelete?: boolean
  deleteTooltip?: string
}

const PhaseBudgetItemRow = (props: Props) => {
  const {
    phaseId,
    role,
    phaseRole,
    rateCard,
    defaultFullTimeMinutes,
    canDelete = false,
    deleteTooltip,
  } = props

  const { watch, setValue } = useFormContext<ProjectBudgetFormData>()
  const formData = watch()

  const effectiveRate = getEffectiveRate(
    role.id,
    rateCard,
    formData.projectRates,
  )

  const rateCardRate = getDefaultRate(rateCard, role.id)

  const handleMinutesChange = (minutes: number) => {
    setValue(
      "phaseAndRoleBudgets",
      formData.phaseAndRoleBudgets.map((pr) =>
        pr.phaseId === phaseId && pr.roleId === role.id
          ? { ...pr, estimatedMinutes: minutes }
          : pr,
      ),
    )
  }

  const handleRemove = () => {
    if (!canDelete) return
    setValue(
      "phaseAndRoleBudgets",
      formData.phaseAndRoleBudgets.filter(
        (pr) => !(pr.phaseId === phaseId && pr.roleId === role.id),
      ),
    )
  }

  return (
    <RoleTableRow
      className={styles.roleTableRow}
      role={{
        id: role.id,
        name: role.name,
        estimatedMinutes: phaseRole.estimatedMinutes,
      }}
      rateCardRate={rateCardRate}
      defaultFullTimeMinutes={defaultFullTimeMinutes}
      canDelete={canDelete}
      deleteTooltip={deleteTooltip}
      onMinutesChange={handleMinutesChange}
      onRemove={handleRemove}
      effectiveRate={effectiveRate}
    />
  )
}

export default PhaseBudgetItemRow
